import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import Constants from "expo-constants";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  KeyboardAvoidingView,
  Platform,
  Dimensions,
  Alert,
  RefreshControl,
} from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import TouchableOpacity from "app/components/TouchableOpacity";
import Autocomplete from "app/components/Autocomplete";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import chapterActions from "app/utils/chapterActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import keyboardHelpers from "app/utils/keyboardHelpers";
import textHelpers from "app/utils/textHelpers";
import timeHelpers from "app/utils/timeHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import chapterHelpers from "app/utils/chapterHelpers";
import colorHelpers from "app/utils/colorHelpers";
import haptics from "app/utils/haptics";
import { HeaderHeightContext } from "@react-navigation/elements";
// import {
//   styleSheet,
//   colors,
//   sizes,
//   screenRatio,
//   WIDTH,
// } from "app/utils/styleSheet";

const HEIGHT = Dimensions.get("window").height;
const THRESHOLD_TO_FETCH_PARENT = 100;

import Chapter from "app/components/Chapter";
import Draggable from "app/components/Draggable";
import BadgeRow from "app/components/chapter/BadgeRow";
import GlobalComposer from "app/components/chapter/GlobalComposer";

import store from "app/redux/store";

const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

import {
  Ionicons,
  Octicons,
  FontAwesome,
  FontAwesome5,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class ListChapters extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props);
    let { navigation, route } = this.props;

    let rangeOptions = ["all", "year", "month", "week", "day"];
    let reversedRangeOptions = [...rangeOptions].reverse();

    this.state = {
      loading: true,
      fetching: true,
      chapters: [],
      atemporalChapters: [],
      expandedIds: [],
      hiddenLevels: -1,
      range:
        route.params?.range ||
        (ENV.WEB ? "month" : "week"),
      // range: "day",
      rangeOptions,
      reversedRangeOptions,
      lastFetchedAt: null,
      initialScrollToComplete: false,
    };
  }

  async componentDidMount() {
    // if (ENV.WEB)
    //   document.addEventListener("keydown", keyboardHelpers.globalListener);
    this.fetch();
    // this.subscribe();
    // let chapters = await chapterActions.index()
    // if (ENV.WEB) window.addEventListener("focus", this.fetch);
  }

  fetch = async () => {
    this.setState({ fetching: true });
    let { range, rangeOptions } = this.state;
    let ts = new Date().getTime();
    let res = await chapterActions.current(range);
    let ts2 = new Date().getTime();
    // alert(`chapter/current complete in ${(ts2 - ts) / 1000}s`);
    console.log(res);
    if (res?.success) {
      // let mindWringChapter = res.sub_chapters?.find((c) =>
      //   chapterHelpers.atemporal(c)
      // );
      await this.setState({
        chapters: res.top_chapters,
        atemporalChapters: res.atemporal_chapters,
        loading: false,
        fetching: false,
        lastFetchedAt: new Date().getTime(),
      });
      if (!this.state.initialScrollToComplete) {
        await new Promise((r) => setTimeout(r, 500));
        // this.scroller.scrollToEnd({ animated: false });

        // let yPos = THRESHOLD_TO_FETCH_PARENT + this.rootChapterHeight;
        // this.scroller.scrollTo({ y: yPos, animated: false });
        // this.setState({ initialScrollToComplete: true });
      }
    } else {
      let error = res?.error || "error";
      console.warn(error);
      let nextRangeIndex = rangeOptions.indexOf(range) - 1;
      if (nextRangeIndex >= 0) {
        await this.setState({ range: rangeOptions[nextRangeIndex] });
        await this.fetch();
      }
    }
  };

  subscribe = async () => {
    this.unsubscribe = store.subscribe(() => {
      let { values, app } = store.getState();
      let { loading, datetime } = app;

      let condensedValues = this.condenseRevisions(values);

      this.setState({
        values: condensedValues,
        // loading,
      });
    });

    // focus
    this.unsubscribeFocus = this.props.navigation.addListener(
      "focus",
      this.handleFocus,
    );
    if (ENV.WEB) window.addEventListener("focus", this.handleFocus);
    this.unsubscribeBlur = this.props.navigation.addListener(
      "blur",
      this.unsubscribe,
    );
    if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
  };

  componentWillUnmount() {
    // if (ENV.WEB)
    //   document.removeEventListener("keydown", keyboardHelpers.globalListener);
    // this.props.navigation.removeListener("focus");
    this.unsubscribeFocus();
    if (ENV.WEB) window.removeEventListener("focus", this.handleFocus);
    // this.props.navigation.removeListener("blur");
    this.unsubscribeBlur();
    if (ENV.WEB) window.removeEventListener("blur", this.handleFocus);
    if (ENV.WEB) window.removeEventListener("focus", this.fetch);
    this.unsubscribe();
  }

  handleFocus = () => {
    console.log("focus");
    this.subscribe();
    // this.updateView(false);
  };

  componentWillUnmount() {
    // this.unsubscribe();
  }

  setRange = async (range) => {
    await this.setState({ range });
    // RootNavigation.updateParams("range", range);
    this.props.navigation.setParams({ range });
    await this.fetch();
  };

  fetchParentChapter = async () => {
    let { range, reversedRangeOptions } = this.state;
    let rangeIndex = reversedRangeOptions.indexOf(range) + 1;
    if (rangeIndex >= reversedRangeOptions.length) {
      return;
    }
    console.warn("fetch parent chapter");

    // const position = contentHeight - this.scrollHeight + this.yOffset;
    // this.scroller.scrollTo({ y: position, animated: false });
    this.contentRef.measure(async (x, y, width, height, pageX, pageY) => {
      const prevScrollerHeight = height;
      console.warn("prev", height);

      await this.setState({ loadingParentChapter: true });
      await this.setRange(reversedRangeOptions[rangeIndex]);
      await this.setState({ loadingParentChapter: false });
      return;
      console.warn("now measure dif");
      this.contentRef.measure(async (x, y, width, newHeight, pageX, pageY) => {
        const newScrollerHeight = newHeight;
        console.warn("new", newHeight);

        const position = newScrollerHeight - prevScrollerHeight + this.yOffset;
        console.warn(
          "diff",
          newScrollerHeight - prevScrollerHeight,
          this.yOffset,
        );
        this.scroller.scrollTo({ y: position, animated: false });
      });
    });
  };

  render() {
    let { loading, chapters, hiddenLevels, loadingParentChapter } = this.state;
    return (
      <View style={{ flex: 1 }}>
        <HeaderHeightContext.Consumer>
          {(headerHeight) => (
            <KeyboardAwareScrollView
              extraScrollHeight={100}
              innerRef={(ref) => (this.scroller = ref)}
              // scrollEventThrottle={100}
              // style={{
              //   borderWidth: 3,
              //   borderColor: "green",
              // }}
              onScroll={(event) => {
                this.yOffset = event.nativeEvent.contentOffset.y;
                // console.log(this.yOffset);
                // if (this.yOffset < THRESHOLD_TO_FETCH_PARENT / 3) {
                //   if (!loadingParentChapter && !loading) {
                //     this.fetchParentChapter();
                //   }
                // }
              }}
              onLayout={() => {
                // this.scroller.scrollToEnd();
              }}
              keyboardShouldPersistTaps={"always"}
              // ref={(ref => this.scrollViewRef = ref)}
              onContentSizeChange={(contentWidth, contentHeight) => {
                // console.warn(
                //   `content size change to ${contentHeight} from ${this.scrollHeight}`
                // );
                // // return;
                // const position = contentHeight - this.scrollHeight + this.yOffset;
                // this.scroller.scrollTo({ y: position, animated: false });
                this.scrollHeight = contentHeight;
              }}

              // refreshControl={
              //   <RefreshControl
              //     refreshing={this.state.fetchingParentChapter}
              //     onRefresh={this.fetchParentChapter}
              //     colors={[this.context.colors.foreground]}
              //     tintColor={this.context.colors.foreground}
              //     progressBackgroundColor={this.context.colors.fill}
              //   />
              // }
            >
              <StatusBar style="auto" />

              <ScrollView
                style={[
                  this.styles().contentWrapper,
                  {
                    minHeight:
                      this.context.sizes.HEIGHT -
                      this.context.sizes.COMPOSER_HEIGHT -
                      headerHeight -
                      200,
                    // Constants.statusBarHeight,
                  },
                  // !loadingParentChapter && { marginTop: THRESHOLD_TO_FETCH_PARENT },
                ]}
                keyboardShouldPersistTaps={"always"}
                contentContainerStyle={this.styles().content}
                scrollEventThrottle={100}
                // ref={(ref) => (this.scroller = ref)}
                onScroll={() => {
                  let lastUpdatedAt = store.getState().dragging.layoutUpdatedAt;
                  let layoutUpdatedAt = new Date().getTime();
                  // if(!lastUpdatedAt || layoutUpdatedAt - lastUpdatedAt > 500){
                  store.dispatch({
                    type: "dragging/set_layout_updated_at",
                    layoutUpdatedAt,
                  });
                  // }
                }}
              >
                <View
                  style={[
                    this.styles().innerContent,
                    !this.state.initialScrollToComplete && { opacity: 0 },
                  ]}
                  ref={(r) => (this.contentRef = r)}
                >
                  {ENV.WEB ? (
                    this.renderRangeButtons()
                  ) : (
                    <View style={this.styles().loadingParentChapterIndicator}>
                      {loadingParentChapter ? (
                        <ActivityIndicator
                          color={this.context.colors.foreground}
                        />
                      ) : this.state.range != "all" && !loading ? (
                        <Text button onPress={this.fetchParentChapter}>
                          Load More
                        </Text>
                      ) : null}
                    </View>
                  )}
                  {/*<Text>
              {hiddenLevels >= 0 && <Text onPress={this.handleZoomOut}>^</Text>}
              <Text> </Text>
              <Text onPress={this.handleZoomIn}>v</Text>
            </Text>*/}
                  {!loading && this.renderList(chapters, 0)}
                  {ENV.WEB && !loading && this.renderAtemporal()}
                  {/*!loading && this.renderFocus()*/}
                </View>
                {!this.state.initialScrollToComplete && (
                  <View style={{ position: "absolute", left: 0, right: 0 }}>
                    <View style={this.styles().loadingParentChapterIndicator}>
                      <ActivityIndicator
                        color={this.context.colors.foreground}
                      />
                    </View>
                  </View>
                )}
              </ScrollView>
            </KeyboardAwareScrollView>
          )}
        </HeaderHeightContext.Consumer>
        <GlobalComposer />
      </View>
    );
  }

  renderRangeButtons = () => {
    let { range, rangeOptions, reversedRangeOptions, fetching } = this.state;
    let rangeIndex = rangeOptions.indexOf(range);
    let content = (
      <View style={this.styles().buttonRow}>
        <View style={[this.styles().refreshButton]}>
          {fetching ? (
            <ActivityIndicator color={this.context.colors.trim} />
          ) : (
            <MaterialCommunityIcons
              name="refresh"
              size={this.context.sizes.large * 1.2}
              color={this.context.colors.trim}
              onPress={() => {
                haptics.light();
                this.fetch();
              }}
            />
          )}
        </View>
        {ENV.WEB && (
          <Autocomplete
            placeholder={"search"}
            // ref={(r) => (this.autoCompleteRef = r)}
            setRef={(r) => {
              this.autoCompleteRef = r;
            }}
            // ref={this.autoCompleteRef}
            globalSearch
            query={this.state.query || ""}
            onChangeText={(text) => {
              this.setState({ query: text });
            }}
            simpleListView
            submitFirstOnPressEnter
            onSelectItem={(value) => {
              RootNavigation.push("Value", { id: value.id });
            }}
            onEnter={(value, event) => {
              if (!!value) {
                RootNavigation.push("Value", { id: value.id }, event);
              } else {
                !!this.autoCompleteRef && this.autoCompleteRef.fetchMore();
              }
            }}
          />
        )}
        {/*<TouchableOpacity
          style={this.styles().button}
          onPress={() => this.setRange(rangeOptions[rangeIndex - 1])}
          disabled={rangeIndex == 0}
        >
          <Text button center selectedButton={!(rangeIndex > 0)}>
            <Feather name="chevron-up" size={this.context.sizes.default} />
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={this.styles().button}
          onPress={() => this.setRange(rangeOptions[rangeIndex + 1])}
          disabled={rangeIndex == rangeOptions.length - 1}
        >
          <Text
            button
            center
            selectedButton={!(rangeIndex < rangeOptions.length - 1)}
          >
            <Feather name="chevron-down" size={this.context.sizes.default} />
          </Text>
        </TouchableOpacity>*/}
        {(ENV.WEB ? rangeOptions : reversedRangeOptions).map((option, i) => {
          return (
            <TouchableOpacity
              key={i}
              style={this.styles().button}
              onPress={() => this.setRange(option)}
              disabled={range == option}
            >
              <Text button selectedButton={range == option} center>
                {textHelpers.capitalize(option)}
              </Text>
            </TouchableOpacity>
          );
        })}
        {/*<View
          style={{ flex: 1, flexDirection: "row", justifyContent: "flex-end" }}
        >
          <TouchableOpacity
            style={[this.styles().button, { marginRight: this.context.sizes.base }]}
            onPress={() => RootNavigation.navigate("TextView")}
          >
            <Text button center selectedButton>
              List
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[this.styles().button, { marginRight: this.context.sizes.base }]}
            onPress={() => RootNavigation.navigate("MomentIndex")}
          >
            <Text button center selectedButton>
              Moments
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[this.styles().button, { marginRight: this.context.sizes.large }]}
            onPress={() => RootNavigation.push("Chapter")}
          >
            <Text button center selectedButton style={{ marginRight: 0 }}>
              <FontAwesome
                name="sticky-note-o"
                size={this.context.sizes.large}
                color={this.context.colors.foreground}
              />
            </Text>
          </TouchableOpacity>
        </View>*/}
      </View>
    );
    if (ENV.WEB) return content;
    else return <ScrollView horizontal>{content}</ScrollView>;
  };

  renderList = (chapters, level) => {
    let { expandedIds, hideCaret, hiddenLevels, initialScrollToComplete } =
      this.state;
    return (
      <Chapter
        expanded
        key={chapters[0]?.id} // force rerender when top level chapters change
        lastFetchedAt={this.state.lastFetchedAt}
        subChaptersOnly
        navigation={this.props.navigation}
        chapter={{ id: "root", current: true }}
        subChapters={chapters}
        rootScrollerRef={this.scroller}
        scrollPageTo={(y) => {
          // console.warn("scrolling page to bottom?", !!this.scroller);
          if (!ENV.WEB) return;
          !!this.scroller &&
            this.scroller.scrollTo({
              y,
              animated: true,
            });
        }}
        // onLayout={async (e, ref) => {
        //   if (!this.state.initialScrollToComplete) {
        //     this.scroller.scrollToEnd({ animated: false });
        //     await new Promise((r) => setTimeout(r, 100));
        //     this.setState({ initialScrollToComplete: true });
        //   }
        // }}
        // onRootChapterLayout={async (e, rootRef) => {
        onRootChapterLayout={
          initialScrollToComplete
            ? null
            : (rootChaptHeight) => {
                // rootRef.measure((x, y, width, height, pageX, pageY) => {
                // this.rootChapterHeight = height;
                this.rootChapterHeight = rootChaptHeight;
                let yPos = this.rootChapterHeight - THRESHOLD_TO_FETCH_PARENT;
                // console.warn("onRootChapterLayout", yPos);
                this.scroller.scrollTo({ y: yPos, animated: false });
                this.setState({ initialScrollToComplete: true });
                // });
              }
        }
      />
    );
    return (
      <Chapter
        chapter={{ id: "root" }}
        subChapters={chapters}
        lastFetchedAt={this.state.lastFetchedAt}
      />
    );
    return (
      <ScrollView
        horizontal
        style={{
          flex: 1,
          marginTop: this.context.sizes.large,
          borderWidth: 3,
          borderColor: "orange",
        }}
        contentContainerStyle={{ flex: 1 }}
      >
        {chapters.map((chapter, i) => {
          return (
            <Chapter
              key={chapter.id}
              lastFetchedAt={this.state.lastFetchedAt}
              chapter={chapter}
              expanded
              hiddenLevels={hiddenLevels}
              navigation={this.props.navigation}
            />
          );
        })}
      </ScrollView>
    );
  };

  renderNodes = (items, level) => {
    let { expandedIds, hideCaret } = this.state;
    return items.map((item, i) => {
      // let expanded = expandedIds.includes(item.id)
      let expanded = false;

      return (
        <View key={item.id} style={this.styles().list}>
          <View style={[this.styles().row]}>
            <View style={[this.styles().valueWrapper]}>
              <Text
                style={this.styles().bullet}
                onPress={() => {
                  console.log(item);
                  this.toggleExpanded(item.id);
                }}
              >
                •{/*expanded ? "v" : ">"*/}
              </Text>
              <Text>{textHelpers.formatTime(item.timestamp)} - </Text>
              <TextInput
                // italic={value.isRevision}
                inputRef={(c) => (this[`ref-${item.id}`] = c)}
                autoFocus={level == 0 && i == 0}
                // onExpand={() => this.toggleExpanded(item.id)}
                // onCollapse={() => this.toggleExpanded(item.id)}
                strike={!!item.completed_at}
                style={[
                  this.styles().textInput,
                  item.completed && { opacity: 0.5 },
                  hideCaret && { caretColor: "transparent" },
                ]}
              >
                {item.text}
              </TextInput>
              {!!item.completed_at && (
                <Text>{textHelpers.formatTime(item.completed_at)}</Text>
              )}
            </View>
          </View>
        </View>
      );
    });
  };

  renderAtemporal = () => {
    // return <View />;
    let { atemporalChapters } = this.state;
    if (!!atemporalChapters?.length) {
      return (
        <View>
          {atemporalChapters.map((chapter, i) => (
            <Chapter
              key={chapter.id}
              lastFetchedAt={this.state.lastFetchedAt}
              chapter={chapter}
              expanded={false}
              navigation={this.props.navigation}
              separateTasks={false}
            />
          ))}
        </View>
      );
    }
    return null;
  };

  renderFocus = () => {
    let { app, preferences, values } = store.getState();
    let { todoIds, focusIds, dismissedTodos } = preferences;
    let focusValues = values
      .filter((v) => focusIds.includes(v.id))
      .map((value) => ({ value }));
    return (
      <View
        style={{
          marginBottom: this.context.sizes.giant,
          marginTop: this.context.sizes.base,
        }}
      >
        <BadgeRow
          index={0}
          moments={focusValues}
          title={"Focus:"}
          // chapter={chapter}
        />
      </View>
    );
  };

  toggleExpanded = (id) => {
    let { expandedIds } = this.state;
    if (expandedIds.includes(id)) {
      expandedIds.splice(expandedIds.indexOf(id), 1);
    } else {
      expandedIds.push(id);
    }
    this.setState({ expandedIds });
  };

  handleZoomOut = () => {
    this.setState({ hiddenLevels: this.state.hiddenLevels - 1 });
  };

  handleZoomIn = () => {
    this.setState({ hiddenLevels: this.state.hiddenLevels + 1 });
  };

  focusNext = async (
    id,
    expanded,
    peers,
    index,
    children,
    uncles,
    parentIndex,
  ) => {
    console.log("focus next");
    let nextId;
    if (expanded && children.length) {
      // first child
      nextId = children[0].id;
    } else if (peers.length && peers.length - 1 > index) {
      // next peer
      nextId = peers[index + 1].id;
    } else {
      // next uncle
      nextId = uncles[parentIndex + 1]?.id;
    }
    if (nextId && this[`ref-${nextId}`]) {
      let ref = this[`ref-${nextId}`];
      if (!!ref?.focus) {
        // ref.addEventListener('focus', this.cursorToBeginning)
        await this.setState({ hideCaret: true });
        ref.focus();
        await new Promise((resolve) => setTimeout(resolve, 0));
        !!ref?.setSelectionRange && ref.setSelectionRange(0, 0);
        await this.setState({ hideCaret: false });
        // ref.removeEventListener('focus', this.cursorToBeginning)
      }
    } else {
      console.log("not found", nextId, this.refs);
    }
  };

  cursorToBeginning = (event) => {
    console.log(
      "listener",
      event?.target?.setSelectionRange,
      event?.srcElement?.setSelectionRange,
    );
    let ref = event?.target;
    ref?.setSelectionRange && ref.setSelectionRange(0, 0);
    ref?.setSelectionRange
      ? console.log("cursor to beginning")
      : console.log("no ref found");
  };

  focusPrevious = (id, peers, index, parent) => {
    console.log("focus previous");
    let prevId;
    if (peers.length && index > 0) {
      // prev peer
      prevId = peers[index - 1].id;
    } else {
      // parent
      prevId = parent.id;
    }
    if (prevId && this[`ref-${prevId}`]) {
      console.log(prevId, this[prevId]);
      this[`ref-${prevId}`].focus && this[`ref-${prevId}`].focus();
    } else {
      console.log("not found", prevId, this.refs);
    }
  };

  styles = () => ({
    container: {
      flex: 1,
    },
    contentWrapper: {
      flex: 1,
      // minHeight: this.context.sizes.HEIGHT,
    },
    loadingParentChapterIndicator: {
      height: THRESHOLD_TO_FETCH_PARENT,
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      // marginTop: this.context.sizes.large,
      paddingLeft: ENV.WEB ? this.context.sizes.large : 0,
    },
    innerContent: {
      flex: 1,
    },
    list: {
      flex: 1,
      marginLeft: ENV.WEB ? this.context.sizes.large : 0,
    },
    row: {
      flexDirection: "row",
      // alignItems: 'center',
      // justifyContent: 'space-between',
      borderColor: this.context.colors.trim,
      // borderBottomWidth: 1,
      borderLeftWidth: 1,
      flex: 1,
    },
    valueWrapper: {
      flex: 1,
      flexDirection: "row",
      padding: 5,
      paddingLeft: 0,
    },
    bullet: {
      width: this.context.sizes.large,
      height: this.context.sizes.large,
      textAlign: "center",
      fontSize: 12,
      borderWidth: 0.5,
      borderColor: this.context.colors.trim,
      borderRadius: this.context.sizes.large / 2,
      marginHorizontal: 3,
    },
    textInput: {
      flex: 1,
      // width: 399,
    },
    buttonRow: {
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: ENV.WEB ? 0 : this.context.sizes.base,
      paddingBottom: this.context.sizes.large,
      paddingTop: this.context.sizes.large,
    },
    button: {
      marginRight: this.context.sizes.base,
    },
    refreshButton: {
      width: this.context.sizes.giant,
      paddingRight: this.context.sizes.large,
      justifyContent: "center",
      alignItems: "center",
    },
  });
}
